import { FC } from 'react';

import { useElementShown } from '@hh.ru/analytics-js';
import vacancySearchQuickFilterApplyButtonClick from '@hh.ru/analytics-js-events/build/xhh/common/vacancy_search/vacancy_search_filter/vacancy_search_quick_filter_apply_button_click';
import vacancySearchQuickFilterListElementShown from '@hh.ru/analytics-js-events/build/xhh/common/vacancy_search/vacancy_search_filter/vacancy_search_quick_filter_list_element_shown';
import { VSpacing } from '@hh.ru/magritte-ui';

import CatalogLinksList, { CatalogLink } from 'src/components/CatalogSearch/CatalogLinksList';

interface CatalogLinksProps {
    links: CatalogLink[];
    title: string;
    hhtmSourceLabel: 'TOP_FILTER_CATALOG' | 'BOTTOM_FILTER_CATALOG' | 'BOTTOM_SIMILAR_QUERY';
    blockDataQa?: string;
}

const CatalogLinks: FC<CatalogLinksProps> = ({ links, title, hhtmSourceLabel, blockDataQa }) => {
    const showLinksContainerRef = useElementShown(vacancySearchQuickFilterListElementShown, {
        filterList: links.map(({ name }) => name).join(', '),
        hhtmSourceLabel,
    });

    const onCatalogLinkClick = (link: CatalogLink, index: number) =>
        vacancySearchQuickFilterApplyButtonClick({
            position: index + 1,
            filter: link.name || '',
            hhtmSourceLabel,
            hhtmSource: 'vacancy_search_list',
        });

    return (
        <>
            <VSpacing default={40} />
            <div ref={showLinksContainerRef} data-qa={blockDataQa}>
                <CatalogLinksList links={links} title={title} clickHandler={onCatalogLinkClick} />
            </div>
        </>
    );
};

export default CatalogLinks;
